import { World2 as o } from "./world-2.js";
import { Globe2 as r } from "./globe-2.js";
import { Global as m } from "./global.js";
import { LocalPaymentMethods as t } from "./local-payment-methods.js";
import { Bank as i } from "./bank.js";
import { Company as p } from "./company.js";
import { FoundedFlag as f } from "./founded-flag.js";
import { Headquarters as e } from "./headquarters.js";
import { Location as a } from "./location.js";
import { LpmApac as n } from "./lpm-apac.js";
import { LpmEmea as l } from "./lpm-emea.js";
import { LpmLatam as s } from "./lpm-latam.js";
import { LpmUs as d } from "./lpm-us.js";
import { Pointer as L } from "./pointer.js";
import { Store as c } from "./store.js";
import { Store2 as u } from "./store-2.js";
import { Windmill as B } from "./windmill.js";
import { Berlin as g } from "./berlin.js";
import { Bicycle as h } from "./biycle.js";
import { Boat as y } from "./boat.js";
import { Bus as k } from "./bus.js";
import { Bus2 as H } from "./bus-2.js";
import { Delivery as P } from "./delivery.js";
import { Door as S } from "./door.js";
import { House as T } from "./house.js";
import { House2 as b } from "./house-2.js";
import { Lighthouse as x } from "./lighthouse.js";
import { London as A } from "./london.js";
import { MilanCathedral as C } from "./milan-cathedral.js";
import { ParisEiffel as D } from "./paris-eiffel.js";
import { Rollerskate as E } from "./rollerskate.js";
import { Singapore as F } from "./singapore.js";
import { Taxi as G } from "./taxi.js";
import { Truck as M } from "./truck.js";
import { UnitedKingdom as U } from "./united-kingdom.js";
const go = {
  World2: o,
  Globe2: r,
  Global: m,
  LocalPaymentMethods: t,
  Bank: i,
  Company: p,
  FoundedFlag: f,
  Headquarters: e,
  Location: a,
  LpmApac: n,
  LpmEmea: l,
  LpmLatam: s,
  LpmUs: d,
  Pointer: L,
  Store: c,
  Store2: u,
  Windmill: B,
  Berlin: g,
  Bicycle: h,
  Boat: y,
  Bus: k,
  Bus2: H,
  Delivery: P,
  Door: S,
  House: T,
  House2: b,
  Lighthouse: x,
  London: A,
  MilanCathedral: C,
  ParisEiffel: D,
  Rollerskate: E,
  Singapore: F,
  Taxi: G,
  Truck: M,
  UnitedKingdom: U
};
export {
  go as LocationsAndTransport
};
